<template>
  <div class="navTab-filtrate">
    <div class="title">
      <img class="img_style" src="@/assets/imgs/nav_icon_back.png" @click="$emit('onFliter')"/>
      <Search :keyName="keyName" style="margin-bottom: 0;width: 95%;padding: 0" @onSearch="onSearch"></Search>
    </div>
    <div class="filtrate-van">
      <div class="brand-list">
        <div v-for="item of brandListbackup" :key="item.id" class="van-typeList van-hairline--bottom">
          <div class="van-brand">
            <p class="brand-name">
              {{ item.name }}{{ item.multiple ? "（多选）" : "" }}
            </p>
            <div>
              <span v-if="item.close" class="text">展开</span>
              <span v-if="!item.close" class="text">折叠</span>
              <img v-if="!item.close" class="iconfont" src="@/assets/imgs/jiantou_down.png" @click="changeClose(item)"/>
              <img v-if="item.close" class="iconfont" src="@/assets/imgs/jiantou_up.png" @click="changeClose(item)"/>
            </div>
          </div>
          <div v-show="!item.close" class="list-all">
            <div v-for="(info, index) of item.options" :key="index" class="brand-list">
              <div :class="{
                  'list-itemed': info.selected,
                  'list-item': !info.selected,
                }" class="brand" @click.stop="selectedItem(item, info)">
                {{ info.value }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="van-content">
      <div class="content-false" @click="reset()">重置</div>
      <div class="content-true" @click="confirm()">确认（已选{{ brandNum }}）</div>
    </div>
  </div>
</template>

<script>
import Search from "./Search.vue";

export default {
  name: "Features-header",
  components: {
    Search
    // biddingSearch
  },
  props: {
    brandList: Array,
  },
  watch: {
    'brandListbackup': {
      handler(newVal) {
        let a = 0
        newVal.forEach(t => {
          t.options.forEach(i => {
            if (i.selected) {
              a += 1;
            }

          })
        })
        this.brandNum = a
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      keyName: "请输入关键字查询",
      brandListbackup: [...this.brandList],
      brandNum: 0,
    };
  },
  computed: {},
  mounted() {
  },
  methods: {
    // 筛选
    onSearch(value) {
      this.$emit('onSearch', value);
      this.$emit('onFliter')
    },
    changeClose(item) {
      this.$set(item, "close", !item.close);
    },
    selectedItem(item, info) {
      if (item.multiple) {
        //多选
        if (info.key == "all") {
          item.options.forEach((vm) => {
            if (vm.value === info.value) {
              this.$set(info, "selected", !info.selected);
            } else {
              this.$set(vm, "selected", false);
            }
          });
        } else {
          this.$set(info, "selected", !info.selected);
          //this.$set(item.options[0], "selected", false);
        }
      } else {
        //单选
        item.options.forEach((vm) => {
          if (vm.value === info.value) {
            this.$set(info, "selected", !info.selected);
          } else {
            this.$set(vm, "selected", false);
          }
        });
      }

      //封信筛选条件
    },
    reset() {
      this.brandListbackup.forEach((item) => {
        item.options.forEach((info) => {
          if (info.key == "all") {
            this.$set(info, "selected", true);
          } else {
            this.$set(info, "selected", false);
          }
        });
      });
      this.$emit("reset");
    },
    confirm() {
      this.$emit("refreshData", this.brandListbackup);
    },
  },
};
</script>

<style lang='stylus' scoped>
.navTab-filtrate {
  position: relative;
  height: auto;
  overflow: auto;

  .title {
    padding: 48px 40px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .img_style {
      width: 16px;
      height: 33px;
      margin-right: 10px;
    }

    span {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
      line-height: 42px;
    }

    img {
      width: 40px;
      height: 40px;
    }
  }

  .filtrate-van {
    display: flex;
    flex-direction: column;
    padding: 0 40px 100px;

    .brand-list {
      .van-typeList {
        &::after {
          display: none;
        }

        .van-brand {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 88px;
          line-height: 88px;

          .brand-name {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 28px;
            color: #333333;
            line-height: 33px;
          }

          .text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 24px;
            color: #666666;
          }

          .iconfont {
            width: 0.4rem;
            height: 0.35rem;
            position: relative;
            top 8px
          }
        }

        .list-all {
          display: flex;
          flex-wrap: wrap;

          .brand-list {
            margin-right: 14px;
            margin-bottom: 24px;

            .brand {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 24px;
              color: #666666;
              padding: 14px 32px;
              background: #F5F5F5;
              border-radius: 8px 8px 8px 8px;
              touch-action: pan-y;
            }

            .list-itemed {
              color: red;
              background: rgba(242, 39, 24, 0.06);
              color: #E0000C;
            }

            .list-item {
            }
          }
        }
      }
    }

    .placeholder {
      width: 100%;
      height: 120px;
    }
  }
}

.van-content {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 112px;
  background: #FFFFFF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 34px;

  .content-false {
    width: 326px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    border-radius: 32px 32px 32px 32px;
    border: 1px solid #D0D0D0;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #666666;
  }

  .content-true {
    width: 326px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    background: #E0000C;
    border-radius: 32px 32px 32px 32px;
    border: 1px solid #E0000C;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 28px;
    color: #FFFFFF;
  }
}
</style>
